import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

export class PageNotFound extends Component {
    render() {
        return (
            <Row>
                <Col sm="12" md={{size: 4, offset: 4}}>
                    <h1>Fout 404</h1>
                    <h2>Deze pagina bestaat niet.</h2>
                    <p>Heeft u de correcte URL ingevoerd?</p>
                </Col>
            </Row>  
        );
    }
}